import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=e52d4fe0&scoped=true"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=e52d4fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52d4fe0",
  null
  
)

export default component.exports